import { useState, useEffect, useContext, useRef } from 'react';

import { InquiryHelpModel } from '../../../../../../models/inquiry/InquiryHelpModel';

function InquiryHelpSearchAidItem(props: any) {

  const inquiryHelpInfo: InquiryHelpModel = props.inquiryHelpInfo;
  const [link, setLink] = useState<string>('');


  useEffect(() => {
    if(inquiryHelpInfo?.id && inquiryHelpInfo?.inquiry_category_id) {
      setLink(`/inquiry/help?category=${inquiryHelpInfo?.inquiry_category_id}&help=${inquiryHelpInfo.id}`);
    }
  }, [inquiryHelpInfo])


  return (
    <>
    {(
      inquiryHelpInfo &&
      inquiryHelpInfo.title &&
      link
    ) &&
      <a
        style={{
          padding: '10px 0',
          borderBottom: '1px solid #f0f0f0',
        }}
        href={link}
      >
        <p style={{
          margin: 0,
          color: '#333',
        }}>{inquiryHelpInfo.title}</p>
      </a>
    }
    </>
  );
}
  
export default InquiryHelpSearchAidItem;